"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KalturaResponse = void 0;
var KalturaResponse = /** @class */ (function () {
    function KalturaResponse(result, error) {
        this.result = result;
        this.error = error;
    }
    return KalturaResponse;
}());
exports.KalturaResponse = KalturaResponse;

//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwaS9rYWx0dXJhLXJlc3BvbnNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBO0lBRUkseUJBQW1CLE1BQVUsRUFBUyxLQUEyQjtRQUE5QyxXQUFNLEdBQU4sTUFBTSxDQUFJO1FBQVMsVUFBSyxHQUFMLEtBQUssQ0FBc0I7SUFJakUsQ0FBQztJQUNMLHNCQUFDO0FBQUQsQ0FQQSxBQU9DLElBQUE7QUFQWSwwQ0FBZSIsImZpbGUiOiJhcGkva2FsdHVyYS1yZXNwb25zZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEthbHR1cmFBUElFeGNlcHRpb24gfSBmcm9tIFwiLi9rYWx0dXJhLWFwaS1leGNlcHRpb25cIjtcblxuZXhwb3J0IGNsYXNzIEthbHR1cmFSZXNwb25zZTxUPiB7XG5cbiAgICBjb25zdHJ1Y3RvcihwdWJsaWMgcmVzdWx0IDogVCwgcHVibGljIGVycm9yIDogS2FsdHVyYUFQSUV4Y2VwdGlvbilcbiAgICB7XG5cblxuICAgIH1cbn1cbiJdfQ==
